import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';
import { TargetSection } from '../../_models/timeline-models/section-models/target-section.model';
import { TimelineSection } from '../../_models/timeline-models/section-listing.model';
import { ProgressSection } from '../../_models/timeline-models/section-models/progress-section.model';
import { ObservationSection } from '../../_models/timeline-models/section-models/observation-section.model';
import { DocumentSection } from '../../_models/timeline-models/section-models/document-section.model';

@Injectable({
  providedIn: 'root'
})
export class TimelineSectionsService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
  ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  getTimelineSections(placementId: number, studentId: number, subject: string, clientId: number) {
    let model = {
      "placementId": placementId,
      "studentID": studentId,
      "subject": subject,
      "clientId": clientId
    };
    return this.http.post(this.apiUrl + 'api/LearningSection/RetrieveStudentTimeLine',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('getTimelineSections'))
      );
  }

  deleteTargetSection(targetSection: TargetSection) {

    return this.http.post(this.apiUrl + 'api/LearningSection/DeleteTargetSection', targetSection, 
    this.prepareOptions(targetSection)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('deleteTargetSection'))
      );
  }

  deleteProgressSection(progressSection: ProgressSection) {

    return this.http.post(this.apiUrl + 'api/LearningSection/DeleteProgressSection', progressSection, 
    this.prepareOptions(progressSection)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('deleteProgressSection'))
      );
  }

  deleteObservationSection(observationSection: ObservationSection) {

    return this.http.post(this.apiUrl + 'api/LearningSection/DeleteObservationSection', observationSection, 
    this.prepareOptions(observationSection)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('deleteObservationSection'))
      );
  }

  mergeTargetSection(placementId: number, studentIds: number[], subject: string, targetSection: TargetSection) {

    let model = this.modelMapper(placementId, studentIds, subject, targetSection);

    return this.http.post(this.apiUrl + 'api/LearningSection/MergeTargetSection',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('mergeTargetSection'))
      );
  }

  mergeDocumentSection(placementId: number, studentIds: number[], subject: string, documentSection: DocumentSection) {

    let model = this.modelMapper(placementId, studentIds, subject, documentSection);

    return this.http.post(this.apiUrl + 'api/LearningSection/MergeDocumentSection',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('mergeDocumentSection'))
      );
  }

  mergeObservationSection(placementId: number, studentIds: number[], subject: string, observationSection: ObservationSection) {

    let model = this.modelMapper(placementId, studentIds, subject, observationSection);

    return this.http.post(this.apiUrl + 'api/LearningSection/MergeObservationSection',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('mergeObservationSection'))
      );
  }

  mergeProgressSection(placementId: number, studentIds: number[], subject: string, progressSection: ProgressSection) {

    let model = this.modelMapper(placementId, studentIds, subject, progressSection);

    return this.http.post(this.apiUrl + 'api/LearningSection/MergeProgressSection',
      model,
      this.prepareOptions(model)).pipe(
        map((data: any) => {

          return data.body;
        }), catchError(this.handleError('mergeProgressSection'))
      );
  }

  private modelMapper(placementId: number, studentIds: number[], subject: string, modelToMap: TimelineSection): any {

    let model = {};
    Object.keys(modelToMap)
      .forEach(key => {
        model[key] = modelToMap[key]
      });

    model["placementId"] = placementId;
    model["studentIds"] = studentIds;
    model["subject"] = subject;

    return model;
  }

}
